/** Sidebar — sık kullanılanlar (localStorage) */

export const FAVORITES_STORAGE_KEY = "mbs_sidebar_favorites_v1";

/** Varsayılan sık kullanılan modüller (MBS operasyon) */
export const DEFAULT_FAVORITES = [
    "/",
    "/takvim",
    "/e/sigorta-dosyalari",
    "/e/muvekkiller",
    "/yeni/tahkim-merkezi",
    "/e/tahkim-dosyalari",
    "/e/odemeler",
    "/e/deger-kaybi",
    "/e/evraklar",
    "/yeni/zaman-asimi",
    "/yeni/odeme-raporlari",
];

export function loadFavorites() {
    try {
        const raw = localStorage.getItem(FAVORITES_STORAGE_KEY);
        if (!raw) return [...DEFAULT_FAVORITES];
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    } catch (_) {
        /* ignore */
    }
    return [...DEFAULT_FAVORITES];
}

export function saveFavorites(paths) {
    try {
        localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(paths));
    } catch (_) {
        /* ignore */
    }
}

export function toggleFavorite(current, path) {
    const next = current.includes(path)
        ? current.filter((p) => p !== path)
        : [...current, path];
    saveFavorites(next);
    return next;
}

export function isFavorite(favorites, path) {
    return favorites.includes(path);
}
